import * as React from "react";
import { P, H1, Content } from "../recurso_literario.js";

export const NetworkPanel = () => {
	return(
	<Content>
		<h2> Panel de Network </h2>
		<P>
			En esta sección podés agregar, configurar y gestionar todo el aprovisionamiento
			de servicios de Redes.
		</P>
		<P>
			Si das click en el ícono de Network, se te desplegarán las opciones de Redes,
			Grupos de Seguridad, Routers e IP públicas entre otros.
		</P>
		<P>
			<img src="/img/Network/NPanel.PNG" alt="Panel de Network"
			style={{marginLeft:"40px"}} />
		</P>
	</Content>
	)
}

export const NetworkNet = () => {
	return(
	<Content>
		<h2> Redes </h2>
		<P>
			En esta sección podés ver las redes que tenés contratadas como servicio y
			también tenés la posibilidad de agregar las que sean necesarias.
		</P>
		<P>
			<img src="/img/Network/NNetwork/NNetwork_View.png" alt="Redes Vista"
			style={{width:"100%", marginLeft:"40px"}} />
		</P>
		<h4>Crear una Red</h4>
		<P>
			Para crear una red necesitás darle clic al botón Agregar de la esquina superior
			izquierda de la vista Redes.
		</P>
		<P>
			<img src="/img/Network/NNetwork/NNetwork_AddButton.png" alt="Crear Red Botón"
			style={{width:"15%", marginLeft:"40px"}} />
		</P>
		<P>
			El primer paso para crear la red es la Configuración, para eso deberemos colocar
			un nombre a nuestra red, un cidr y el default Gateway, también tenés la opción
			de activar la opción de conexión con un router de borde. Para continuar le damos
			clic al botón siguiente de la parte inferior derecha de la vista.
		</P>
		<P>
			<img src="/img/Network/NNetwork/NNetwork_NewConfig.png" alt="Nueva Red Configuración"
			style={{width:"80%", marginLeft:"40px"}} />
		</P>
		<P>
			En el segundo paso podés habilitar o deshabilitar el DHCP y tenés la opción de
			agregar un Pool.
		</P>
		<P>
			<img src="/img/Network/NNetwork/NNetwork_NewDhcp.png" alt="Nueva Red DHCP"
			style={{width:"80%", marginLeft:"40px"}} />
		</P>
		<P>
			Para ello sólo debes dar clic en el botón de Agregar Pool y llenar el formulario
			correspondiente.
		</P>
		<P>
			<img src="/img/Network/NNetwork/NNetwork_NewAddPool.png" alt="Nueva Red Pool"
			style={{width:"80%", marginLeft:"40px"}} />
		</P>
		<P>
			Para finalizar podrás ver la configuración seleccionada para la red.
		</P>
		<P>
			<img src="/img/Network/NNetwork/NNetwork_NewConfirm.png" alt="Nueva Red Confirmación"
			style={{width:"80%", marginLeft:"40px"}} />
		</P>
		<P>
			Para crear la misma sólo tenés que dar clic en el botón Crear Red.
		</P>
		<P>
			<img src="/img/Network/NNetwork/NNetwork_NewCreateButton.png" alt="Botón Crear Red"
			style={{width:"15%", marginLeft:"40px"}} />
		</P>

		<h4>Edición y Detalles de la Red</h4>
		<P>
			Para acceder a los detalles de las redes creadas sólo debemos darle clic al nombre
			de esta y se nos abrirá una vista con la información. Desde aquí, además, se puede modificar el 
			nombre de la red haciendo clic en el lápiz que está a la derecha del mismo.
		</P>
		<P>
			<img src="/img/Network/NNetwork/NNetwork_Detail.png" alt="Detalles de la Red"
			style={{width:"100%", marginLeft:"40px"}} />
		</P>
		<P>
			Podemos ver la información de los puertos dando clic en el botón Puerto de la
			barra superior de la vista.
		</P>
		<P>
			<img src="/img/Network/NNetwork/NNetwork_Ports.png" alt="Configuración de Puertos"
			style={{width:"100%", marginLeft:"40px"}} />
		</P>
		<P>
			También podemos editar la configuración de nuestra red dando clic en el botón
			Configuración de la barra superior de la vista. Desde allí se puede desconectar/conectar al 
			Router de borde según se encuentre conectado o desconectado del mismo respectivamente.
			En caso de querer conectarlo, mueva el switch y siga las instrucciones que se detallan.
		</P>
		<P>
			<img src="/img/Network/NNetwork/NNetwork_Config.png" alt="Configuración de Red"
			style={{width:"100%", marginLeft:"40px"}} />
		</P>
		<P>
			Luego de aplicar los cambios en la configuración debemos darle clic al botón
			Aplicar en la parte inferior de la vista.
		</P>
		<P>
			<img src="/img/Network/NNetwork/NNetwork_ApplyButton.png" alt="Botón Aplicar"
			style={{width:"10%", marginLeft:"40px"}} />
		</P>

		<h4>Eliminar una Red</h4>
		<P>
			Para eliminar una red debemos dar clic al nombre de esta en la vista de redes, luego
			en la parte inferior de la vista encontraremos un botón de nombre Eliminar, al que
			debemos presionar.
		</P>
		<P>
			<img src="/img/Network/NNetwork/NNetwork_DeleteButton.png" alt="Botón Eliminar"
			style={{width:"10%", marginLeft:"40px"}} />
		</P>
		<P>
			Una ventana de confirmación se abrirá, debemos presionar Aceptar o Cancelar en el
			caso de que hayamos tocado el botón Eliminar por error.
		</P>
		<P>
			<img src="/img/Network/NNetwork/NNetwork_DeleteAlert.png" alt="Confirmación Eliminar"
			style={{width:"50%", marginLeft:"40px"}} />
		</P>
	</Content>
    )
}

export const NetworkGroups = () => {
	return(
	<Content>
		<H1> Grupos de Seguridad </H1>
		<P>
			Los grupos de seguridad determinan el tráfico entrante o saliente permitido desde o
			hacia un puerto en particular de la VM. La regla general dicata "Lo que no está
			permitido, está denegado".
		</P>
		<P>
			<img src="/img/Network/NGroup/NGroup_View.PNG" alt="Grupos Vista"
			style={{width:"100%", marginLeft:"40px"}} />
		</P>

		<h2>El grupo de seguridad default </h2>

		<P>
			Toda nube es creada inicalmente con el grupo de seguridad default. El mismo
			permite solo tódo el tráfico saliente del puerto en el cual se aplique. El
			tráfico entrante está denegado. Recuerda que la regla es "Lo que no está
			permitido, está denegado".
		</P>
		<P>
			El grupo de seguridad default no puede ser eliminado o modificado.
		</P>

		<h2>Acceso al DHCP y cómo toman IP las VM</h2>

		<P>
			Si conectaste una VM a una red que tiene el DHCP activado y deseas que tome
			ip mediante éste mecanismo, debes asegurarte que el tráfico saliente al
			puerto UDP 67 desde la interfaz de red de la VM esté permitido.
		</P>
		<P>
			Para ello la interfaz de red debe tener asignada al menos un grupo de seguridad
			y éste debe tener permitido el tráfico UDP 67 saliente. Una opción es que utilices
			el grupo de seguridad defaut
		</P>

		<h2>Acciones sobre los Grupos de Seguridad </h2>
		<h4>Agregar un Grupo</h4>
		<P>
			Para agregar un grupo debemos dar clic en el botón Agregar de la vista de Grupos de
			Seguridad, ubicado en la esquina superior izquierda de esta.
		</P>
		<P>
			<img src="/img/Network/NGroup/NGroup_AddButton.PNG" alt="Crear Grupo Botón"
			style={{marginLeft:"40px"}} />
		</P>
		<P>
			Se abrirá una ventana emergente con un formulario donde deberás colocar el nombre
			del grupo y una breve descripción de este. Al darle al botón Aceptar, ya el grupo
			aparecerá en la vista de grupos de seguridad.
		</P>
		<P>
			<img src="/img/Network/NGroup/NGroup_AddGroup.PNG" alt="Nuevo Grupo"
			style={{width:"50%", marginLeft:"40px"}} />
		</P>

		<h4>Detalles y Edición de los Grupos</h4>
		<P>
			Para conocer los detalles de cada grupo solo hay que dar clic en el nombre de este
			que se encuentra en la lista de grupos de seguridad creados. Obtendremos una vista
			con información general del grupo, así como las reglas asignadas a este y las IPs.
		</P>
		<P>
			<img src="/img/Network/NGroup/NGroup_Detail.PNG" alt="Detalle de Grupo"
			style={{width:"100%", marginLeft:"40px"}} />
		</P>
		<P>
			Si queremos editar el grupo y crear reglas, debemos dar clic al botón de
			Configuración en la barra superior de la vista de detalles.
		</P>
		<P>
			<img src="/img/Network/NGroup/NGroup_Config.PNG" alt="Configuración de Grupo"
			style={{width:"100%", marginLeft:"40px"}} />
		</P>
		<P>
			Después de hacer cualquier modificación debemos dar clic al botón Salvar de la
			parte inferior de la vista.
		</P>
		<P>
			<img src="/img/Network/NGroup/NGroup_SaveButton.PNG" alt="Botón Guardar"
			style={{width:"10%", marginLeft:"40px"}} />
		</P>

		<h4>Crear Nuevas Reglas</h4>
		<P>
			Para crear nuevas reglas, hay que dar clic en el botón Agregar de la sección
			de Reglas de la vista Configuración de los grupos de seguridad.
		</P>
		<P>
			<img src="/img/Network/NGroup/NGroup_AddRulesButton.PNG" alt="Botón Nueva Regla"
			style={{width:"15%", marginLeft:"40px"}} />
		</P>
		<P>
			Se abrirá un formulario en una ventana emergente en el que podemos seleccionar
			el sentido, el protocolo, los rangos de puertos, especificar el puerto y la red
			a la que aplicará la regla. Para finalizar solo debemos dar clic en Aceptar.
		</P>
		<P>
			<img src="/img/Network/NGroup/NGroup_AddRules.PNG" alt="Nueva Regla"
			style={{width:"80%", marginLeft:"40px"}} />
		</P>

		<h4>Eliminar un Grupo</h4>
		<P>
			Para eliminar un grupo debemos acceder a la vista de detalles del grupo dando clic
			al nombre de este. Luego en la parte inferior encontraremos el botón Eliminar.
		</P>
		<P>
			<img src="/img/Network/NGroup/NGroup_DeleteButton.PNG" alt="Botón Eliminar Grupo"
			style={{width:"10%", marginLeft:"40px"}} />
		</P>
		<P>
			Al dar clic al botón Eliminar nos aparecerá una ventana emergente donde podremos
			confirmar la eliminación del grupo o cancelar en el caso de que hayamos pulsado el
			botón por error.
		</P>
		<P>
			<img src="/img/Network/NGroup/NGroup_DeleteConfirm.PNG" alt="Confirmar Eliminar Grupo"
			style={{width:"50%", marginLeft:"40px"}} />
		</P>
	</Content>
	)
}

export const NetworkRouters = () => {
	return(
	<Content>
		<h2> Routers </h2>
		<P>
			En la vista de Routers podemos crear y gestionar Routers para nuestra administración
			de redes.
		</P>
		<P>
			<img src="/img/Network/NRouters/NRouters_View.PNG" alt="Routers Vista"
			style={{width:"100%", marginLeft:"40px"}} />
		</P>

		<h4>Agregar Routers</h4>
		<P>
			Para agregar un nuevo Router hay que dar clic en el botón Agregar de parte superior
			izquierda de la vista.
		</P>
		<P>
			<img src="/img/Network/NRouters/NRouters_AddRouterButton.PNG" alt="Botón Crear Routers"
			style={{marginLeft:"40px"}} />
		</P>
		<P>
			Se abrirá una ventana emergente con un formulario donde podremos indicar el nombre
			de nuestro Router y dando clic en Aceptar, lo podremos ver reflejado en la lista de
			Routers contratados.
		</P>
		<P>
			<img src="/img/Network/NRouters/NRouters_AddRouter.PNG" alt="Crear Routers"
			style={{width:"50%", marginLeft:"40px"}} />
		</P>

		<h4>Detalles y Puertos</h4>
		<P>
			Para consultar los detalles de un router solo tenemos que dar clic en el nombre de
			este y se nos mostrara una vista con la información detallada.
		</P>
		<P>
			<img src="/img/Network/NRouters/NRouters_Detail.PNG" alt="Detalles del Router"
			style={{width:"100%", marginLeft:"40px"}} />
		</P>
		<P>
			Si queremos ver el listado de puertos del router solo debemos dar clic al botón
			Puertos de la barra superior de la vista.
		</P>
		<P>
			<img src="/img/Network/NRouters/NRouters_Ports.PNG" alt="Puertos del Router"
			style={{width:"100%", marginLeft:"40px"}} />
		</P>

		<h4>Alta de un Puerto</h4>
		<P>
			Para dar de alta un nuevo puerto al router tenemos que entrar en la vista detallada
			del router y dar clic en el botón Puertos de la barra superior de la vista. Luego,
			en la zona inferior podremos encontrar un botón llamado Alta de Puerto que debemos
			presionar.
		</P>
		<P>
			<img src="/img/Network/NRouters/NRouters_NewPortButton.PNG" alt="Botón Alta Puertos"
			style={{width:"15%", marginLeft:"40px"}} />
		</P>
		<P>
			Aparecerá una ventana emergente donde podremos a través del formulario, seleccionar la red.
		</P>
		<P>
			<img src="/img/Network/NRouters/NRouters_NewPort.PNG" alt="Nuevo Puerto"
			style={{width:"50%", marginLeft:"40px"}} />
		</P>

		<h4>Mover un Router a un Nuevo Proyecto</h4>
		<P>
			En la vista detallada de un router encontraremos en la parte inferior de esta, un botón
			llamado Mover Proyecto, donde al hacer clic podremos asignar nuestro router a un nuevo
			proyecto que hayamos creado previamente.
		</P>
		<P>
			<img src="/img/Network/NRouters/NRouters_MoveRouterButton.PNG" alt="Botón Mover Router"
			style={{width:"15%", marginLeft:"40px"}} />
		</P>
		<P>
			Al hacer clic aparecerá una ventana emergente donde usaremos la lista para seleccionar
			el nuevo proyecto.
		</P>
		<P>
			<img src="/img/Network/NRouters/NRouters_MoveRouter.png" alt="Mover Router"
			style={{width:"50%", marginLeft:"40px"}} />
		</P>

		<h4>Eliminar un Router</h4>
		<P>
			Para eliminar un router, debemos dar clic en el nombre de este para ir a la vista
			detallada de este, luego en la parte inferior de la vista podremos encontrar el botón
			Eliminar.
		</P>
		<P>
			<img src="/img/Network/NRouters/NRouters_DeleteRouterButton.PNG" alt="Botón Eliminar Router"
			style={{width:"10%", marginLeft:"40px"}} />
		</P>
		<P>
			Al dar clic nos aparece una ventana emergente para confirmar la decisión y al dar
			Aceptar podremos eliminar el router de manera definitiva o podemos dar clic en Cancelar
			y volver a la vista anterior en el caso de que hayamos dado clic por error.
		</P>
		<P>
			<img src="/img/Network/NRouters/NRouters_DeleteRouter.PNG" alt="Eliminar Router"
			style={{width:"50%", marginLeft:"40px"}} />
		</P>
	</Content>
	)
}

export const NetworkIPs = () => {
	return(
	<Content>
		<h2> IPs Públicas </h2>
		<P>
			En la vista de IPs Públicas podremos sumar como recursos IPs que podamos usar en
			diferentes equipos dentro de nuestra red de manera dinámica.
		</P>
		<P>
			<img src="/img/Network/NIPs/NIPs_View.PNG" alt="IPs Públicas Vista"
			style={{maxWidth:"900px", marginLeft:"40px"}} />
		</P>

		<h4>Agregar una IP Publica</h4>
		<P>
			Para agregar una nueva IP Publica es necesario dar clic en el botón Agregar de
			la esquina superior izquierda de la vista.
		</P>
		<P>
			<img src="/img/Network/NIPs/NIPs_AddButton.PNG" alt="Botón Agregar IP"
			style={{marginLeft:"40px"}} />
		</P>
		<P>
			En la vista del alta de la IP Publica encontraremos dos sectores, un sector
			izquierdo compuesto por el presupuesto y el otro sector derecho el del alta, para
			proceder al alta solo tienes que darle clic al botón Aceptar y se procederá a
			asignar la IP.
		</P>
		<P>
			<img src="/img/Network/NIPs/NIPs_AddView.PNG" alt="Vista Agregar IP"
			style={{maxWidth:"900px", marginLeft:"40px"}} />
		</P>

		<h4>Detalles de una IP Publica</h4>
		<P>
			Para conocer los datos de una IP Publica previamente creada solo tenemos que
			dar clic en la dirección de esta y se nos mostrara la información detalla de esta.
			Además, en el apartado Finanzas verás lo consumido actualmente, el precio por hora y el 
			estimado a fin de mes.
		</P>
		<P>
			<img src="/img/Network/NIPs/NIPs_Detail.png" alt="Detalles de una IP"
			style={{maxWidth:"900px", marginLeft:"40px"}} />
		</P>

		<h4>Mover una IP Publica</h4>
		<P>
			Para mover una IP Publica a otro proyecto, debemos darle clic a la dirección
			IP de la que queremos cambiar y en la vista de detalle encontraremos el botón
			Mover de Proyecto en la parte inferior, donde debemos hacer clic.
		</P>
		<P>
			<img src="/img/Network/NIPs/NIPs_MoveButton.PNG" alt="Botón Mover una IP"
			style={{marginLeft:"40px"}} />
		</P>
		<P>
			Luego se abrirá una ventana emergente donde debemos seleccionar de la lista
			desplegable el proyecto al que queremos mover nuestra IP, cada resaltar que
			debemos tener dos o más proyectos creados para realizar esta acción. Al
			finalizar damos clic en aceptar y nuestra IP se moverá.
		</P>
		<P>
			<img src="/img/Network/NIPs/NIPs_Move.png" alt="Mover una IP"
			style={{marginLeft:"40px"}} />
		</P>

		<h4>Eliminar una IP Publica</h4>
		<P>
			Para eliminar una IP Publica, debemos darle clic a la dirección IP de la que
			queremos eliminar y en la vista de detalle encontraremos el botón Eliminar en
			la parte inferior, donde debemos hacer clic.
		</P>
		<P>
			<img src="/img/Network/NIPs/NIPs_DeleteIPButton.PNG" alt="Botón Eliminar una IP"
			style={{marginLeft:"40px"}} />
		</P>
		<P>
			Luego se nos abrirá una ventana de confirmación donde debemos darle Aceptar para
			continuar con la eliminación o cancelar por si se dio clic al botón por error o
			se cambio de opinión sobre la acción.
		</P>
		<P>
			<img src="/img/Network/NIPs/NIPs_DeleteIP.png" alt="Eliminar una IP"
			style={{marginLeft:"40px"}} />
		</P>
	</Content>
	)
}
